module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/privacy/privacy.component.scss
// module id = ./src/app/privacy/privacy.component.scss
// module chunks = main